import { InjectionToken, WritableSignal, signal } from '@angular/core';

/** State shared by every group of one composer. */
export interface PathFilterComposerState {
  /** Id of the group whose add menu opens as soon as it renders; the group clears it once opened. */
  openAddMenuFor: WritableSignal<string | null>;
  /** Id of the node the pointer or the focus is on, in the rows or in the phrase; both light it. */
  hovered: WritableSignal<string | null>;
}

export const PATH_FILTER_COMPOSER_STATE = new InjectionToken<PathFilterComposerState>(
  'PATH_FILTER_COMPOSER_STATE'
);

export function createComposerState(): PathFilterComposerState {
  return {
    openAddMenuFor: signal<string | null>(null),
    hovered: signal<string | null>(null)
  };
}
